import type { BodyBlock } from '@/mocks/articles';

interface ArticleBodyProps {
  blocks: BodyBlock[];
}

export default function ArticleBody({ blocks }: ArticleBodyProps) {
  return (
    <div className="max-w-none">
      {blocks.map((block, index) => {
        if (block.type === 'h2') {
          return (
            <h2
              key={index}
              id={`sec-${index}`}
              className="mt-10 mb-4 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug border-l-4 border-primary-500 pl-4"
            >
              {block.text}
            </h2>
          );
        }
        return (
          <p key={index} className="mt-5 text-[15px] md:text-base text-foreground-700 leading-[1.95]">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}